import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
  Menu,
  Grid,
  Paper
} from "@mui/material";
import { Add, Delete, Edit, Undo, RestartAlt, QueryStats, ContentCopy, Download, CardGiftcard, FileDownload, ExpandMore, Assessment, PictureAsPdf, EventAvailable, Grading, BarChart, PhotoLibrary } from "@mui/icons-material";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import {
  IEnrollmentList,
  ISSRSRequestPayload,
  IWaitingList,
  IWorkshopAssessmentMonitor,
  IWorkshopEvaluationMonitor,
} from "models/workshop";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { QueryClient, useMutation, useQueryClient } from "react-query";

import {
  AttendedListCells,
  WaitingListCells,
  getWorkshopDetails,
  getWorkshopDetailsWithCorrectEmployeeIds,
  getSSRSReport,
  WorkshopAssessmentMonitorCells,
  WorkshopEvaluationMonitorCells,
  WorkshopEvaluationListCells,
  downloadAssessmentReport,
  downloadPretestGradesReport,
  downloadPretestAnalysisReport,
  downloadWorkshopExcelSummaryReport,
  downloadWorkshopReport,
  downloadWorkshopAttendeesChronologicalReport,
  getEnrollmentStatus,
} from "framework/workshops";
import { getCompanyById } from "framework/company";
import { exportQuestionsPdf, exportQuestionsExcel } from "framework/vendorAssessmentQuestion";
import { getEvaluationProgress, getEvaluationProgressByWorkshopId, getWorkshopEvaluation, getWorkshopEvaluationByWorkshopId } from "framework/workshopEvaluation";
import { handleError, exportToExcel } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import BackButton from "components/UI/BackButton";
import { formatDate, formatDateTime, getUserData } from "helpers";
import EmptyContent from "components/EmptyContent";
import {
  addInvitation,
  deleteInvitation,
  getInvitations,
  getUninvitedEmployeesAsync,
  InvitationCells,
} from "framework/workshopInvitations";
import {
  ISelectedEmployeesForInvitation,
  IWorkshopInvitations,
  IWorkshopInvitationsInput,
} from "models/workshopInvitations";
import DeleteWorkshopInvitation from "Pages/WorkshopInvitation/partials/DeleteWorkshopInvitation/DceleteWorkshopInvitation";
import { UserRoleName, UserType } from "types/auth";
import { IVendorAssessmentType } from "models/vendorAssessmentType";
import { getVendorAssessmentTypes } from "framework/vendorAssessmentType";
import { IWorkshopAssessments, IWorkshopAssessmentsInput } from "models/workshopAssessments";
import { IWorkshopEvaluationListItem } from "models/workshop";
import { IWorkshopEvaluation } from "models/workshopEvaluation";
import { addWorkshopAssessments, changeEnrollmentStatus, deleteWorkshopAssessments, editWorkshopAssessments, getAssessmentProgress, getWorkshopAssessments, WorkshopAssessmentsCells, WorkshopAssessmentsCellsExtra, getEmployeesWithVouchers, createVouchersForEmployees } from "framework/workshopAssessments";
import AddWorkshopAssessment from "Pages/WorkshopAssessments/partials/AddWorkshopAssessment/AddWorkshopAssessment";
import DeleteWorkshopAssessment from "Pages/WorkshopAssessments/partials/DeleteWorkshopAssessment/DeleteWorkshopAssessment";
import { getVendorAssessmentDefinitions } from "framework/vendorAssessmentDefinition";
import { IVendorAssessmentDefinition } from "models/vendorAssessmentDefinition";
import AddWorkshopInvitations2 from "Pages/WorkshopInvitation/partials/AddWorkshop/AddWorkshopInvitations2";
import EditWorkshopAssessment from "Pages/WorkshopAssessments/partials/EditWorkshopAssessment/EditWorkshopAssessment";
import useFetchSection from "hooks/useFetchSection";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import MuiButton from "components/UI/MuiButton/MuiButton";
import Modal from 'components/UI/DialogModal';
import { resetAssessment, unfinishAssessment } from "framework/employeeWorkshopAssessment";
import { resetEvaluation, unfinishEvaluation } from "framework/employeeWorkshopEvaluation";
import WorkshopPhotosModal from 'components/WorkshopPhotosModal';
import { getAllPermission } from 'helpers';
import VoucherEmployeesModal from './partials/VoucherEmployeesModal/VoucherEmployeesModal';


interface Props {
  feature: Feature;
}

const WorkshopDetails: React.FC<Props> = ({ feature }) => {
  const urlParams = useParams();
  let id: string = urlParams[`${feature.singleName}Id`] as string;
  const userData = getUserData();
  const { colors, user, roleName } = userData;
  const userType = user.userType;
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingCerts, setLoadingCerts] = useState<boolean>(false);
  const [loadingPretestReport, setLoadingPretestReport] = useState<boolean>(false);
  const [loadingPretestAnalysis, setLoadingPretestAnalysis] = useState<boolean>(false);
  const [loadingWorkshopSummaryExcel, setLoadingWorkshopSummaryExcel] = useState<boolean>(false);
  const [loadingWorkshopReport, setLoadingWorkshopReport] = useState<boolean>(false);
  const [loadingAttendeesChronological, setLoadingAttendeesChronological] = useState<boolean>(false);
  const [downloadingAssessmentId, setDownloadingAssessmentId] = useState<string | null>(null);
  const [downloadingExcelAssessmentId, setDownloadingExcelAssessmentId] = useState<string | null>(null);
  const [exportMenuAnchor, setExportMenuAnchor] = useState<{ element: HTMLElement; assessmentId: string } | null>(null);

  const [reportsMenuAnchor, setReportsMenuAnchor] = useState<HTMLElement | null>(null);

  const [moreActionsMenuAnchor, setMoreActionsMenuAnchor] = useState<HTMLElement | null>(null);
  const [isError, setIsError] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const [loading2, setLoading2] = useState<boolean>(false);
  const [inputAssessmentObj, setInputAssessmentObj] = useState<IWorkshopAssessmentsInput>(
    {} as IWorkshopAssessmentsInput
  );
  const [Invitations, setInvitations] = useState<IWorkshopInvitations[]>(
    [] as IWorkshopInvitations[]
  );
  const [filteredUninvitedEmployeesList, setFilteredUninvitedEmployeesList] =
    useState<ISelectedEmployeesForInvitation[]>(
      [] as ISelectedEmployeesForInvitation[]
    );
  const { setAlert } = useAlert();
  const [openAddInvitation, setOpenAddInvitation] = useState<boolean>(false);
  const [openAddAssessment, setOpenAddAssessment] = useState<boolean>(false);
  const [openEditAssessment, setOpenEditAssessment] = useState<boolean>(false);
  const [openMonitorAssessment, setOpenMonitorAssessment] = useState<boolean>(false);
  const [openDeleteInvitation, setOpenDeleteInvitation] =
    useState<boolean>(false);
  const [openDeleteAssessment, setOpenDeleteAssessment] =
    useState<boolean>(false);
  const handleOpenAddInvitation = () => setOpenAddInvitation(true);
  const handleOpenAddAssessment = () => setOpenAddAssessment(true);
  const [selectedWorkshopInvitation, setSelectedWorkshopInvitation] =
    useState<IWorkshopInvitations>({} as IWorkshopInvitations);
  const [vendorAssessmentTypes, setVendorAssessmentTypes] = useState<IVendorAssessmentType[]>(
    [] as IVendorAssessmentType[]
  );
  const [workshopAssessments, setWorkshopAssessments] = useState<IWorkshopAssessments[]>(
    [] as IWorkshopAssessments[]
  );
  const [vendorAssessmentDefinitions, setVendorAssessmentDefinitions] = useState<IVendorAssessmentDefinition[]>(
    [] as IVendorAssessmentDefinition[]
  );
  const [enrollmentStatus, setEnrollmentStatus] = useState<{id: number, english: string}[]>(
    [] 
  );
  const [selectedWorkshopAssessment, setSelectedWorkshopAssessment] =
    useState<IWorkshopAssessments>({} as IWorkshopAssessments);
  const [workshopAssessmentMonitorList, setWorkshopAssessmentMonitorList] =
    useState<IWorkshopAssessmentMonitor[]>([] as IWorkshopAssessmentMonitor[]);
  const [workshopEvaluationMonitorList, setWorkshopEvaluationMonitorList] =
    useState<IWorkshopEvaluationMonitor[]>([] as IWorkshopEvaluationMonitor[]);
  const [loadingMonitor, setLoadingMonitor] = useState<boolean>(false);
  const [loadingEvaluationMonitor, setLoadingEvaluationMonitor] = useState<boolean>(false);
  const selectedAssessmentIdRef = useRef<string | null>(null);
  const [openMonitorEvaluation, setOpenMonitorEvaluation] = useState<boolean>(false);
  const [workshopEvaluationList, setWorkshopEvaluationList] = useState<IWorkshopEvaluationListItem[]>([]);
  const [openPhotosModal, setOpenPhotosModal] = useState<boolean>(false);
  const [hasPhotosPermission, setHasPhotosPermission] = useState<boolean>(false);
  const [openVouchersModal, setOpenVouchersModal] = useState<boolean>(false);
  const [employeesWithVouchers, setEmployeesWithVouchers] = useState<any[]>([]);
  const [loadingVouchers, setLoadingVouchers] = useState<boolean>(false);
  const [hasAttendancePermission, setHasAttendancePermission] = useState<boolean>(false);
  const [hasGradesPermission, setHasGradesPermission] = useState<boolean>(false);
  const [hasWorkshopDetailsAssessmentPermission, setHasWorkshopDetailsAssessmentPermission] = useState<boolean>(false);
  const [hasWorkshopDetailsAssessmentRead, setHasWorkshopDetailsAssessmentRead] = useState<boolean>(false);
  const [hasWorkshopDetailsAssessmentModify, setHasWorkshopDetailsAssessmentModify] = useState<boolean>(false);
  const [hasWorkshopDetailsAssessmentDelete, setHasWorkshopDetailsAssessmentDelete] = useState<boolean>(false);
  const [hasWorkshopAssessmentVouchersPermission, setHasWorkshopAssessmentVouchersPermission] = useState<boolean>(false);
  const [hasWorkshopAssessmentVouchersRead, setHasWorkshopAssessmentVouchersRead] = useState<boolean>(false);
  const [hasWorkshopAssessmentVouchersModify, setHasWorkshopAssessmentVouchersModify] = useState<boolean>(false);
  const [hasWorkshopDetailsEvaluationPermission, setHasWorkshopDetailsEvaluationPermission] = useState<boolean>(false);
  const [hasWorkshopDetailsEvaluationRead, setHasWorkshopDetailsEvaluationRead] = useState<boolean>(false);
  const [hasWorkshopDetailsEvaluationModify, setHasWorkshopDetailsEvaluationModify] = useState<boolean>(false);
  const [hasReportsPermission, setHasReportsPermission] = useState<boolean>(false);
  const [allPermissions, setAllPermissions] = useState<any[]>([]);
  const [hasScoreDataPermission, setHasScoreDataPermission] = useState<boolean>(false);
  const [hasEvaluationDataPermission, setHasEvaluationDataPermission] = useState<boolean>(false);
  const [hasWorkshopModifyPermission, setHasWorkshopModifyPermission] = useState<boolean>(false);
  const [enrollmentLink, setEnrollmentLink] = useState<string>("");

  const queryClient = useQueryClient();

  // Generate enrollment link on mount
  useEffect(() => {
    if (id) {
      const link = `${window.location.origin}/workshop-enrollment/${id}`;
      setEnrollmentLink(link);
    }
  }, [id]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(enrollmentLink);
      setAlert({
        open: true,
        message: t("T_create_link_success") || "Enrollment link copied successfully!",
        type: "success",
      });
    } catch (err) {
      setAlert({
        open: true,
        message: "Failed to copy link",
        type: "error",
      });
    }
  };

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (openMonitorAssessment) {
      fetchAssessmentMonitor(); // call immediately
      intervalRef.current = setInterval(fetchAssessmentMonitor, 10000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [openMonitorAssessment]);
  
  const handleOpenDeleteInvitation = (invitation: IWorkshopInvitations) => {
    setSelectedWorkshopInvitation(invitation);
    setOpenDeleteInvitation(true);
  };

  const handleOpenDeleteAssessment = (workshopAssessment: IWorkshopAssessments) => {
    setSelectedWorkshopAssessment(workshopAssessment);
    setOpenDeleteAssessment(true);
  };

  const handleOpenEditAssessment = (workshopAssessment: IWorkshopAssessments) => {
    setSelectedWorkshopAssessment(workshopAssessment);
    setOpenEditAssessment(true);
  };

  const handleOpenMonitorAssessment = (workshopAssessment: IWorkshopAssessments) => {
    setSelectedWorkshopAssessment(workshopAssessment);
    selectedAssessmentIdRef.current = workshopAssessment?.id || null;
    setOpenMonitorAssessment(true);
    fetchAssessmentMonitor();
  };

  const handleOpenVouchersModal = async (workshopAssessment: IWorkshopAssessments) => {
    if (!hasWorkshopAssessmentVouchersRead) {
      setAlert({
        open: true,
        message: t("T_no_permissions_message") || "You don't have permission to view vouchers",
        type: "error",
      });
      return;
    }
    setSelectedWorkshopAssessment(workshopAssessment);
    setOpenVouchersModal(true);
    setLoadingVouchers(true);
    try {
      const employees = await getEmployeesWithVouchers(workshopAssessment.id);
      setEmployeesWithVouchers(employees);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Failed to load employees with vouchers",
        type: "error",
      });
    } finally {
      setLoadingVouchers(false);
    }
  };

  const handleCloseVouchersModal = () => {
    setOpenVouchersModal(false);
    setEmployeesWithVouchers([]);
    setSelectedWorkshopAssessment({} as IWorkshopAssessments);
  };

  const handleSendVouchers = async (selectedEmployees: Array<{ employeeId: string; discount: number }>) => {
    if (!selectedWorkshopAssessment?.id) return;
    
    if (!hasWorkshopAssessmentVouchersModify) {
      setAlert({
        open: true,
        message: t("T_no_permissions_message") || "You don't have permission to create vouchers",
        type: "error",
      });
      return;
    }
    
    if (!selectedEmployees || selectedEmployees.length === 0) {
      setAlert({
        open: true,
        message: "Please select at least one employee",
        type: "warning",
      });
      return;
    }

    try {
      setLoadingVouchers(true);
      await createVouchersForEmployees(selectedWorkshopAssessment.id, selectedEmployees);
      setAlert({
        open: true,
        message: "Vouchers created successfully",
        type: "success",
      });
      // Refresh the list
      const employees = await getEmployeesWithVouchers(selectedWorkshopAssessment.id);
      setEmployeesWithVouchers(employees);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Failed to create vouchers",
        type: "error",
      });
    } finally {
      setLoadingVouchers(false);
    }
  };

  const handleOpenMonitorEvaluation = () => {
    setOpenMonitorEvaluation(true);
  };


  const handleClose = () => {
    setOpenDeleteInvitation(false);
    setOpenAddInvitation(false)
    setOpenAddAssessment(false)
    setOpenEditAssessment(false)
    setOpenMonitorAssessment(false)
    setOpenMonitorEvaluation(false)
    setOpenDeleteAssessment(false)
    setInputAssessmentObj({} as IWorkshopAssessmentsInput)
  };

  const deleteInvitationMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteInvitation(id);
    },
  });


  const {
    loading: loadingWorkshops,
    data: Workshop,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getWorkshopDetailsWithCorrectEmployeeIds("/" + id),
    fetchPermission: () => null!,
    section: "get Workshop Details"
  });

  // Fetch evaluation details when workshop is loaded
  useEffect(() => {
    const fetchEvaluationDetails = async () => {
      // Check permission first
      if (!hasWorkshopDetailsEvaluationPermission || !id) {
        setWorkshopEvaluationList([]);
        return;
      }

      try {
        const evaluation: IWorkshopEvaluation = await queryClient.fetchQuery(
          ["get workshop evaluation by workshop id", id],
          () => getWorkshopEvaluationByWorkshopId(id),
          {
            staleTime: 5 * 60 * 1000, // Cache for 5 minutes
            cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
          }
        );
        
        if (evaluation) {
          setWorkshopEvaluationList([{
            id: evaluation.id,
            workshopEvaluationId: evaluation.id,
            title: evaluation.title,
            timeToComplete: evaluation.timeToComplete || 0,
            isActive: evaluation.isActive || false
          }]);
        } else {
          setWorkshopEvaluationList([]);
        }
      } catch (error) {
        console.error('Error fetching evaluation:', error);
        // If evaluation not found (404) or error, set empty list
        setWorkshopEvaluationList([]);
      }
    };

    fetchEvaluationDetails();
    // eslint-disable-next-line
  }, [id, hasWorkshopDetailsEvaluationPermission]);



  const fetchAssessmentMonitor = useCallback(async () => {
    const assessmentId = selectedAssessmentIdRef.current;
    if (!assessmentId) return;
    setLoadingMonitor(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get workshop assessment",
        () =>
          getAssessmentProgress(
            `?workshopAssessmentId=${assessmentId}`
          )
      );
      response =
        response && response.length > 0
          ? response.map((item: IWorkshopAssessmentMonitor) => ({
            ...item,
          }))
          : [];
      setWorkshopAssessmentMonitorList(response);
      setLoadingMonitor(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoadingMonitor(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  const fetchEvaluationMonitor = useCallback(async () => {
    if (!id) return;
    setLoadingEvaluationMonitor(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get workshop evaluation progress",
        () =>
          getEvaluationProgressByWorkshopId(id)
      );
      response =
        response && response.length > 0
          ? response.map((item: IWorkshopEvaluationMonitor) => ({
            ...item,
          }))
          : [];
      setWorkshopEvaluationMonitorList(response);
      setLoadingEvaluationMonitor(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoadingEvaluationMonitor(false);
    }
    // eslint-disable-next-line
  }, [queryClient, setAlert, id]);

  const evaluationIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const fetchEvaluationMonitorRef = useRef(fetchEvaluationMonitor);
  
  // Keep the ref updated with the latest function
  useEffect(() => {
    fetchEvaluationMonitorRef.current = fetchEvaluationMonitor;
  }, [fetchEvaluationMonitor]);

  useEffect(() => {
    if (openMonitorEvaluation) {
      fetchEvaluationMonitorRef.current(); // call immediately
      evaluationIntervalRef.current = setInterval(() => {
        fetchEvaluationMonitorRef.current();
      }, 10000);
    } else {
      if (evaluationIntervalRef.current) {
        clearInterval(evaluationIntervalRef.current);
        evaluationIntervalRef.current = null;
      }
    }

    // Cleanup on unmount
    return () => {
      if (evaluationIntervalRef.current) {
        clearInterval(evaluationIntervalRef.current);
      }
    };
    // eslint-disable-next-line
  }, [openMonitorEvaluation]);







  const fetchData = async () => {
    setLoading(true);
    try {
      // First, get workshop details to get the companyId
      const workshopDetails = await getWorkshopDetails("/" + id);
      const workshopCompanyId = workshopDetails?.workshopDetails?.[0]?.companyId;

      const [
        invitationsResponse,
        uninvitedEmployeesResponse,
        vendorAssessmentTypesResponse,
        workshopAssessmentsResponse,
        vendorAssessmentDefinitionsResponse
      ] = await Promise.all([

        queryClient.fetchQuery("get invitations", () =>
          getInvitations(`?workshopId=${id}`)),
        queryClient.fetchQuery("get work invitations",
          () =>
            getUninvitedEmployeesAsync(
              `?workshopId=${id}`
            )),
        queryClient.fetchQuery("get vendor assessment types",
          () =>
            getVendorAssessmentTypes('/byvendor')
        ),
        queryClient.fetchQuery("get workshop assessment",
          () =>
            getWorkshopAssessments('/byworkshop?workshopId=' + id))
        ,
        queryClient.fetchQuery("get vendor assessment definitions",
          () => getVendorAssessmentDefinitions(`/forworkshops${workshopCompanyId ? `?companyId=${workshopCompanyId}` : ''}`))
      ]);

      setInvitations(invitationsResponse);
      setFilteredUninvitedEmployeesList(uninvitedEmployeesResponse);
      setVendorAssessmentTypes(vendorAssessmentTypesResponse);
      setWorkshopAssessments(workshopAssessmentsResponse);
      setVendorAssessmentDefinitions(vendorAssessmentDefinitionsResponse);
      setLoading(false);
      
      // Debug: Log workshop assessments to check for isCertifiedtest property
      // console.log('Workshop Assessments Response:', workshopAssessmentsResponse);
      // if (workshopAssessmentsResponse && workshopAssessmentsResponse.length > 0) {
      //   workshopAssessmentsResponse.forEach((assessment: any, index: number) => {
      //     console.log(`Assessment ${index}:`, {
      //       id: assessment.id,
      //       typeName: assessment.typeName,
      //       isCertifiedtest: assessment.isCertifiedtest,
      //       IsCertifiedtest: assessment.IsCertifiedtest,
      //       isPretest: assessment.isPretest,
      //       isPosttest: assessment.isPosttest,
      //       fullObject: assessment
      //     });
      //   });
      // }
    } catch (error: any) {

      setLoading(false);
      setIsError(true);
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });

    }
  };

    const fetchEnrollmentStatus = async () => {
    try {
      const enrollmentStatus = await getEnrollmentStatus();
setEnrollmentStatus(enrollmentStatus)

    } catch (error: any) {

    }
  };

  useEffect(() => {
    fetchData()
    checkAllPermissions()
    fetchEnrollmentStatus()
    // eslint-disable-next-line
  }, []);


  const checkAllPermissions = async () => {
    try {
      const permissions = await getAllPermission();
      setAllPermissions(permissions || []);
      
      // Check WorkshopPhotos permission
      const photosPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopPhotos'
      );
      setHasPhotosPermission(
        photosPermission?.hasReadPermission || 
        photosPermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopAttendance permission
      const attendancePermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopAttendance'
      );
      setHasAttendancePermission(
        attendancePermission?.hasReadPermission || 
        attendancePermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopGrades permission
      const gradesPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopGrades'
      );
      setHasGradesPermission(
        gradesPermission?.hasReadPermission || 
        gradesPermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopReports permission
      const reportsPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopReports'
      );
      setHasReportsPermission(
        reportsPermission?.hasReadPermission || 
        reportsPermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopScoreData permission
      const scoreDataPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopScoreData'
      );
      setHasScoreDataPermission(
        scoreDataPermission?.hasReadPermission || 
        scoreDataPermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopEvaluationData permission
      const evaluationDataPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopEvaluationData'
      );
      setHasEvaluationDataPermission(
        evaluationDataPermission?.hasReadPermission || 
        evaluationDataPermission?.hasModifyPermission || 
        false
      );

      // Check Workshop modify permission for enrollment link
      const workshopPermission = permissions?.find(
        (p) => p.permissionName === 'Workshop'
      );
      setHasWorkshopModifyPermission(
        workshopPermission?.hasModifyPermission || 
        false
      );

      // Check WorkshopDetailsAssessment permission
      const assessmentPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopDetailsAssessment'
      );
      const hasRead = assessmentPermission?.hasReadPermission || false;
      const hasModify = assessmentPermission?.hasModifyPermission || false;
      const hasDelete = assessmentPermission?.hasDeletePermission || false;
      const hasFullControl = assessmentPermission?.hasFullControl || false;
      const hasAny = hasRead || hasModify || hasDelete || hasFullControl;
      
      setHasWorkshopDetailsAssessmentPermission(hasAny);
      setHasWorkshopDetailsAssessmentRead(hasRead || hasFullControl);
      setHasWorkshopDetailsAssessmentModify(hasModify || hasFullControl);
      setHasWorkshopDetailsAssessmentDelete(hasDelete || hasFullControl);

      // Check WorkshopAssessmentVouchers permission
      const vouchersPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopAssessmentVouchers'
      );
      const vouchersHasRead = vouchersPermission?.hasReadPermission || false;
      const vouchersHasModify = vouchersPermission?.hasModifyPermission || false;
      const vouchersHasFullControl = vouchersPermission?.hasFullControl || false;
      const vouchersHasAny = vouchersHasRead || vouchersHasModify || vouchersHasFullControl;
      
      setHasWorkshopAssessmentVouchersPermission(vouchersHasAny);
      setHasWorkshopAssessmentVouchersRead(vouchersHasRead || vouchersHasFullControl);
      setHasWorkshopAssessmentVouchersModify(vouchersHasModify || vouchersHasFullControl);
      
      console.log('WorkshopAssessmentVouchers Permission Debug:', {
        vouchersPermission,
        vouchersHasRead,
        vouchersHasModify,
        vouchersHasFullControl,
        vouchersHasAny,
        finalRead: vouchersHasRead || vouchersHasFullControl
      });

      // Check WorkshopDetailsEvaluation permission
      const evaluationPermission = permissions?.find(
        (p) => p.permissionName === 'WorkshopDetailsEvaluation'
      );
      const evalHasRead = evaluationPermission?.hasReadPermission || false;
      const evalHasModify = evaluationPermission?.hasModifyPermission || false;
      const evalHasFullControl = evaluationPermission?.hasFullControl || false;
      const evalHasAny = evalHasRead || evalHasModify || evalHasFullControl;
      
      // console.log('WorkshopDetailsEvaluation Permission Debug:', {
      //   evaluationPermission,
      //   evalHasRead,
      //   evalHasModify,
      //   evalHasFullControl,
      //   evalHasAny
      // });
      
      setHasWorkshopDetailsEvaluationPermission(evalHasAny);
      setHasWorkshopDetailsEvaluationRead(evalHasRead || evalHasFullControl);
      setHasWorkshopDetailsEvaluationModify(evalHasModify || evalHasFullControl);
    } catch (error) {
      console.error('Error checking permissions:', error);
    }
  };

  const sendInvitationsMutation = useMutation({
    mutationFn: (createInput: IWorkshopInvitationsInput) => {
      return addInvitation({
        ...createInput
      });
    },
  });

  const unfinishWorkshopAssessment = useMutation({
    mutationFn: (assessmentId: string) => {
      return unfinishAssessment(
        assessmentId
      );
    },
  });

  const resetWorkshopAssessment = useMutation({
    mutationFn: (assessmentId: string) => {
      return resetAssessment(
        assessmentId
      );
    },
  });

  const unfinishWorkshopEvaluation = useMutation({
    mutationFn: (evaluationId: string) => {
      return unfinishEvaluation(evaluationId);
    },
  });

  const resetWorkshopEvaluation = useMutation({
    mutationFn: (evaluationId: string) => {
      return resetEvaluation(evaluationId);
    },
  });


  const addWorkshopAssessmentMutation = useMutation({
    mutationFn: (createInput: IWorkshopAssessmentsInput) => {
      return addWorkshopAssessments(createInput);
    },
  });

  const editWorkshopAssessmentMutation = useMutation({
    mutationFn: (data: { createInput: IWorkshopAssessmentsInput; id: string }) => {
      return editWorkshopAssessments(data.createInput, data.id);
    },
  });

  const deleteWorkshopAssessmentMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteWorkshopAssessments(id);
    },
  });

   const changeEnrollmentStatusMutation = useMutation({
    mutationFn: (createInput: {id:string;status:number}) => {
      return changeEnrollmentStatus(createInput);
    },
  });

  const handleSendInvitations = async (selectedEmployees: string) => {
    if (!selectedEmployees)
      return setAlert({
        open: true,
        message: "Please select at least one employee",
        type: "error",
      });
    try {
      setLoading2(true);
      await sendInvitationsMutation.mutateAsync({ id: id, employeeIds: selectedEmployees });
      setAlert({
        open: true,
        message: "Workshop invitations sent successfully",
        type: "success",
      });
      fetchData();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleAddAssessment = async () => {
    if (
      !inputAssessmentObj.assessmentDefinitionId ||
      !inputAssessmentObj.typeId ||
      !inputAssessmentObj.timeToComplete
    )
      return setAlert({
        open: true,
        message: "Please fill all fields",
        type: "error",
      });
    try {
      setLoading2(true);

      inputAssessmentObj.workshopId = id;
      await addWorkshopAssessmentMutation.mutateAsync(inputAssessmentObj);
      setAlert({
        open: true,
        message: "Assessment added successfully",
        type: "success",
      });
      handleClose();
      setInputAssessmentObj({} as IWorkshopAssessments);
      fetchData();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEditAssessment = async () => {
    try {
      setLoading2(true);
      let createInput: IWorkshopAssessmentsInput = {
        active: inputAssessmentObj.active !== null && inputAssessmentObj.active !== undefined
          ? inputAssessmentObj.active
          : selectedWorkshopAssessment.active,
        timeToComplete: inputAssessmentObj.timeToComplete || selectedWorkshopAssessment.timeToComplete,
        assessmentDefinitionId: selectedWorkshopAssessment.assessmentDefinitionId,
        workshopId: selectedWorkshopAssessment.workshopId,
        typeId: selectedWorkshopAssessment.typeId
      };
      await editWorkshopAssessmentMutation.mutateAsync({
        createInput,
        id: selectedWorkshopAssessment.id,
      });
      setAlert({
        open: true,
        message: "Assessment updated successfully",
        type: "success",
      });
      handleClose();
      fetchData();
      setInputAssessmentObj({} as IWorkshopAssessmentsInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDeleteAssessment = async () => {
    try {
      setLoading2(true);

      await deleteWorkshopAssessmentMutation.mutateAsync(selectedWorkshopAssessment.id);
      setAlert({
        open: true,
        message: "Assessment Deleted successfully",
        type: "success",
      });
      handleClose();
      fetchData();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDownloadAll = async () => {
    setLoadingCerts(true);

    // Only include attendees with enrollment status = 1 (Enrolled)
    const attendeesList: any = Workshop?.enrollmentList?.filter(
      (enrollment: IEnrollmentList) => Number(enrollment.status) === 1
    ) || [];

    if (!attendeesList || attendeesList.length === 0) {
      setLoadingCerts(false);
      setAlert({
        open: true,
        message: t('T_no_enrolled_attendees') || 'No enrolled attendees found for certificate download',
        type: 'warning',
      });
      return;
    }

    const companyId = Workshop?.workshopDetails?.[0]?.companyId;

    // Fetch company to get certificateName
    let certificateName = 'Certificate-NextLMS-Width'; // Default fallback
    if (companyId) {
      try {
        const company = await getCompanyById(companyId);
        if (company?.certificateName) {
          certificateName = company.certificateName;
        }
      } catch (error) {
        console.error('Error fetching company certificate name:', error);
        // Use default if fetch fails
      }
    }

    const zip = new JSZip();

    for (const attendee of attendeesList) {
      const payload: ISSRSRequestPayload = {
        Path: `/Report Project1/${certificateName}`,
        SSRSParams: [
          { Name: 'workshopId', Value: attendee.workshopId },
          { Name: 'employeeid', Value: attendee.employeeId },
        ],
      };

      try {
        const blob = await getSSRSReport(payload);
        const filename = `${attendee.name.replace(/ /g, '_')}.pdf`;
        zip.file(filename, blob);
      } catch (error) {
        console.error(`Error for ${attendee.name}:`, error);
      }
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'Certificates.zip');
    });
    setLoadingCerts(false);
  };

  const handleDownloadAssessmentReport = async () => {
    if (!id) return;
    
    try {
      setLoadingCerts(true);
      const blob = await downloadAssessmentReport(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Questions-Analysis-Report-${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setLoadingCerts(false);
    } catch (error: any) {
      const errorMessage = handleError(error);
      setAlert({
        open: true,
        message: errorMessage || 'Failed to download assessment report',
        type: 'error',
      });
      setLoadingCerts(false);
    }
  };

  const handleDownloadPretestGradesReport = async () => {
    if (!id) return;

    try {
      setLoadingPretestReport(true);
      const blob = await downloadPretestGradesReport(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Pretest-Grades-Report-${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      const errorMessage = handleError(error);
      setAlert({
        open: true,
        message: errorMessage || 'Failed to download pre-test grades report',
        type: 'error',
      });
    } finally {
      setLoadingPretestReport(false);
    }
  };

const handleDownloadPretestAnalysisReport = async () => {
  if (!id) return;

  try {
    setLoadingPretestAnalysis(true);
    const blob = await downloadPretestAnalysisReport(id);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Pretest-Analysis-Report-${id}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const errorMessage = handleError(error);
    setAlert({
      open: true,
      message: errorMessage || 'Failed to download pre-test analysis report',
      type: 'error',
    });
  } finally {
    setLoadingPretestAnalysis(false);
  }
};

const handleDownloadWorkshopReport = async () => {
  if (!id) return;

  try {
    setLoadingWorkshopReport(true);
    const blob = await downloadWorkshopReport(id);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const title =
      Workshop?.workshopDetails?.[0]?.topicName?.replace(/\s+/g, '-') ||
      'Workshop';
    link.download = `${title}-Report.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    setAlert({
      open: true,
      message: 'Workshop report downloaded successfully',
      type: 'success',
    });
  } catch (error: any) {
    const errorMessage = handleError(error);
    setAlert({
      open: true,
      message: errorMessage || 'Failed to download workshop report',
      type: 'error',
    });
  } finally {
    setLoadingWorkshopReport(false);
  }
};

const handleDownloadWorkshopSummaryExcel = async () => {
  if (!id) return;

  try {
    setLoadingWorkshopSummaryExcel(true);
    const blob = await downloadWorkshopExcelSummaryReport(id);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const title = Workshop?.workshopDetails?.[0]?.topicName?.replace(/\s+/g, '-') || 'Workshop';
    link.download = `${title}-Summary.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    setAlert({
      open: true,
      message: t('T_workshop_excel_report_success'),
      type: 'success',
    });
  } catch (error: any) {
    const errorMessage = handleError(error);
    setAlert({
      open: true,
      message: errorMessage || t('T_workshop_excel_report_failed'),
      type: 'error',
    });
  } finally {
    setLoadingWorkshopSummaryExcel(false);
  }
};

const handleDownloadAttendeesChronologicalReport = async (format: 'pdf' | 'excel' = 'excel') => {
  if (!id) return;

  try {
    setLoadingAttendeesChronological(true);
    const blob = await downloadWorkshopAttendeesChronologicalReport(id, format);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const title = Workshop?.workshopDetails?.[0]?.topicName?.replace(/\s+/g, '-') || 'Workshop';
    const extension = format === 'pdf' ? 'pdf' : 'xlsx';
    link.download = `${title}-Attendees-Chronological.${extension}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    setAlert({
      open: true,
      message: t('T_attendees_chronological_report_success') || 'Attendees chronological report downloaded successfully',
      type: 'success',
    });
  } catch (error: any) {
    const errorMessage = handleError(error);
    setAlert({
      open: true,
      message: errorMessage || t('T_attendees_chronological_report_failed') || 'Failed to download attendees chronological report',
      type: 'error',
    });
  } finally {
    setLoadingAttendeesChronological(false);
  }
};

  const handleDownloadQuestionsListPdf = async (assessment: IWorkshopAssessments) => {
    if (!assessment || !assessment.assessmentDefinitionId) {
      setAlert({
        open: true,
        message: 'Invalid assessment',
        type: 'error',
      });
      return;
    }

    try {
      setDownloadingAssessmentId(assessment.id);
      const blob = await exportQuestionsPdf(assessment.assessmentDefinitionId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const title = assessment.assessmentDefinitionTitle || 'Assessment';
      link.download = `${title?.replace(/\s+/g, '-')}-Questions.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setDownloadingAssessmentId(null);
    } catch (error: any) {
      const errorMessage = handleError(error);
      setAlert({
        open: true,
        message: errorMessage || 'Failed to download questions list',
        type: 'error',
      });
      setDownloadingAssessmentId(null);
    }
  };

  const handleDownloadQuestionsListExcel = async (assessment: IWorkshopAssessments) => {
    if (!assessment || !assessment.assessmentDefinitionId) {
      setAlert({
        open: true,
        message: 'Invalid assessment',
        type: 'error',
      });
      return;
    }

    try {
      setDownloadingExcelAssessmentId(assessment.id);
      const blob = await exportQuestionsExcel(assessment.assessmentDefinitionId);
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      const title = assessment.assessmentDefinitionTitle || 'Assessment';
      link.download = `${title?.replace(/\s+/g, '-')}-Questions.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setDownloadingExcelAssessmentId(null);
    } catch (error: any) {
      const errorMessage = handleError(error);
      setAlert({
        open: true,
        message: errorMessage || 'Failed to download questions list',
        type: 'error',
      });
      setDownloadingExcelAssessmentId(null);
    }
  };

  const openExportMenu = (e: React.MouseEvent<HTMLButtonElement>, assessment: IWorkshopAssessments) => {
    setExportMenuAnchor({ element: e.currentTarget, assessmentId: assessment.id });
  };

  const closeExportMenu = () => {
    setExportMenuAnchor(null);
  };

  const handleOpenReportsMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setReportsMenuAnchor(event.currentTarget);
  };

  const handleCloseReportsMenu = () => {
    setReportsMenuAnchor(null);
  };

  const handleOpenMoreActionsMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMoreActionsMenuAnchor(event.currentTarget);
  };

  const handleCloseMoreActionsMenu = () => {
    setMoreActionsMenuAnchor(null);
  };

  const downloadCertificateMutation = useMutation({
    mutationFn: async (payload: ISSRSRequestPayload) => {
      const blob = await getSSRSReport(payload);
      return blob;
    },
    onSuccess: (blob, variables) => {
      const filename = variables.SSRSParams.find(p => p.Name === 'employeeid')?.Value + '.pdf';
      saveAs(blob, filename);
    },
    onError: () => {
      alert('Error downloading the certificate');
    }
  });

  if (loading || loadingWorkshops)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );
  if (isError)
    return (
      <Alert severity="error">
        Something went wrong, please try again later.
      </Alert>
    );

  const handleWorkshopAssessmentChange = (name: string, value: any) => {
    if (name === "active" && value == null) {
      value = false;
    }
    setInputAssessmentObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Example handler
const handleStatusChange = async(id: string, status: string) => {
try {
  const response = await changeEnrollmentStatusMutation.mutateAsync({
      id,
      status: +status
    });
   return setAlert({
        open: true,
        message: "Successfully changed status",
        type: "success",
      });

} catch (error) {
  
}
   
};

  const handleExportEnrollmentList = () => {
    if (!Workshop?.enrollmentList || Workshop.enrollmentList.length === 0) {
      setAlert({
        open: true,
        message: t('T_no_data_to_export'),
        type: 'warning',
      });
      return;
    }

    const workshopTitle = Workshop?.workshopDetails?.[0]?.topicName || 'Workshop';

    const exportData = Workshop.enrollmentList.map((item) => ({
      ...item,
      status: item.statusString,
    }));

    exportToExcel({
      data: exportData,
      headers: ['name', 'status', 'department', 'email', 'phoneNumber'],
      fileName: `${workshopTitle.replace(/\s+/g, '-')}-Enrollment-List.xlsx`,
    });

    setAlert({
      open: true,
      message: t('T_export_success'),
      type: 'success',
    });
  };

  const workshopDetailsInfo = Workshop?.workshopDetails?.[0];
  const statusLabel =
    workshopDetailsInfo?.status === 1
      ? "Active"
      : workshopDetailsInfo?.status === 2
      ? "Postponed"
      : workshopDetailsInfo?.status === 3
      ? "Cancelled"
      : null;
  const dateRange =
    workshopDetailsInfo?.fromDate && workshopDetailsInfo?.toDate
      ? `${formatDate(workshopDetailsInfo.fromDate)} - ${formatDate(workshopDetailsInfo.toDate)}`
      : null;
  const timeRange =
    workshopDetailsInfo?.fromTime && workshopDetailsInfo?.toTime
      ? `${workshopDetailsInfo.fromTime} - ${workshopDetailsInfo.toTime}`
      : workshopDetailsInfo?.fromTime || workshopDetailsInfo?.toTime || null;

  const detailItems = [
    { id: 'vendor', label: t("T_vendors"), value: workshopDetailsInfo?.vendorName },
    { id: 'venue', label: t("T_venus"), value: workshopDetailsInfo?.venueName },
    { id: 'trainer', label: t("T_trainers"), value: workshopDetailsInfo?.trainer },
    { id: 'topic', label: t("T_topics"), value: workshopDetailsInfo?.topicName },
    { id: 'company', label: t("T_company"), value: workshopDetailsInfo?.companyName },
    { id: 'status', label: t("T_status"), value: statusLabel },
    { id: 'roomNumber', label: t("T_room_number"), value: workshopDetailsInfo?.roomNumber },
    { id: 'capacity', label: t("T_capacity"), value: workshopDetailsInfo?.capacity },
    { id: 'date', label: t("T_date"), value: dateRange },
    { id: 'time', label: t("T_time"), value: timeRange },
  ].filter((item) => item.value !== null && item.value !== undefined && item.value !== "");

  type DropdownMenuItem = {
    key: string;
    label: string;
    to?: string;
    action?: () => void;
    disabled?: boolean;
    showLoader?: boolean;
    icon?: React.ReactNode;
  };

  // Granular permission checks for each report
  // Check "Reports" permission (backend uses "Reports" but frontend might use "WorkshopReports")
  const reportsPermission = allPermissions?.find(
    (p) => p.permissionName === 'Reports' || p.permissionName === 'WorkshopReports'
  );
  const hasReportsReadPermission = reportsPermission?.hasReadPermission || false;

  // Check "WorkshopComprehensiveReport" permission for Workshop Report PDF
  const workshopComprehensiveReportPermission = allPermissions?.find(
    (p) => p.permissionName === 'WorkshopComprehensiveReport'
  );
  const hasWorkshopComprehensiveReportPermission = 
    workshopComprehensiveReportPermission?.hasReadPermission || 
    workshopComprehensiveReportPermission?.hasModifyPermission || 
    false;

  const reportMenuItems: DropdownMenuItem[] = [];
  const moreActionsMenuItems: DropdownMenuItem[] = [];

  // Questions Analysis Report - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'questionsAnalysis',
      label: t('T_questions_analysis_report') || 'Questions Analysis Report',
      action: handleDownloadAssessmentReport,
      disabled: loadingCerts,
      showLoader: loadingCerts,
      icon: <Assessment fontSize="small" />,
    });
  }

  // Pre-Test Grades Report - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'pretestGrades',
      label: t('T_pretest_grades_report') || 'Pre-Test Grades Report',
      action: handleDownloadPretestGradesReport,
      disabled: loadingPretestReport,
      showLoader: loadingPretestReport,
      icon: <Download fontSize="small" />,
    });
  }

  // Pre-Test Analysis Report - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'pretestAnalysis',
      label: t('T_pretest_analysis_report') || 'Pre-Test Analysis Report',
      action: handleDownloadPretestAnalysisReport,
      disabled: loadingPretestAnalysis,
      showLoader: loadingPretestAnalysis,
      icon: <BarChart fontSize="small" />,
    });
  }

  // Workshop Summary Excel - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'workshopSummary',
      label: t('T_workshop_excel_report') || 'Workshop Summary Excel',
      action: handleDownloadWorkshopSummaryExcel,
      disabled: loadingWorkshopSummaryExcel,
      showLoader: loadingWorkshopSummaryExcel,
      icon: <FileDownload fontSize="small" />,
    });
  }

  // Workshop Report PDF - requires WorkshopComprehensiveReport permission
  if (hasWorkshopComprehensiveReportPermission) {
    reportMenuItems.push({
      key: 'workshopReport',
      label: t('T_workshop_report_pdf') || 'Workshop Report',
      action: handleDownloadWorkshopReport,
      disabled: loadingWorkshopReport,
      showLoader: loadingWorkshopReport,
      icon: <PictureAsPdf fontSize="small" />,
    });
  }

  // Attendees Chronological Report (Excel) - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'attendeesChronologicalExcel',
      label: t('T_attendees_chronological_report_excel') || 'Attendees List Report (Excel)',
      action: () => handleDownloadAttendeesChronologicalReport('excel'),
      disabled: loadingAttendeesChronological,
      showLoader: loadingAttendeesChronological,
      icon: <FileDownload fontSize="small" />,
    });
  }

  // Attendees Chronological Report (PDF) - requires Reports permission
  if (hasReportsReadPermission) {
    reportMenuItems.push({
      key: 'attendeesChronologicalPdf',
      label: t('T_attendees_chronological_report_pdf') || 'Attendees List Report (PDF)',
      action: () => handleDownloadAttendeesChronologicalReport('pdf'),
      disabled: loadingAttendeesChronological,
      showLoader: loadingAttendeesChronological,
      icon: <PictureAsPdf fontSize="small" />,
    });
  }

  if (hasAttendancePermission) {
    moreActionsMenuItems.push({
      key: 'attendance',
      label: t('T_attendance') || 'Attendance',
      to: `/trainees-evaluation/${id}`,
      icon: <EventAvailable fontSize="small" />,
    });
  }

  if (hasGradesPermission) {
    moreActionsMenuItems.push({
      key: 'grading',
      label: t('T_grading') || 'Grading',
      to: `/trainees-grades/${id}`,
      icon: <Grading fontSize="small" />,
    });
  }

  if (hasScoreDataPermission) {
    moreActionsMenuItems.push({
      key: 'scoreData',
      label: t('T_score_data') || 'Score Data',
      to: `/workshop-score-data/${id}`,
      icon: <QueryStats fontSize="small" />,
    });
  }

  if (hasEvaluationDataPermission) {
    moreActionsMenuItems.push({
      key: 'evaluationData',
      label: t('T_evaluation_data') || 'Evaluation Data',
      to: `/workshop-evaluation-data/${id}`,
      icon: <Assessment fontSize="small" />,
    });
  }

  if (hasWorkshopModifyPermission) {
    moreActionsMenuItems.push({
      key: 'copyLink',
      label: 'Copy Enrollment Link',
      action: handleCopyLink,
      icon: <ContentCopy fontSize="small" />,
    });
  }

  if (hasPhotosPermission) {
    moreActionsMenuItems.push({
      key: 'photos',
      label: t('T_workshop_photos') || 'Workshop Photos',
      action: () => setOpenPhotosModal(true),
      icon: <PhotoLibrary fontSize="small" />,
    });
  }

  const reportsMenuOpen = Boolean(reportsMenuAnchor);
  const moreActionsMenuOpen = Boolean(moreActionsMenuAnchor);
  const dropdownButtonStyles = {
    height: '44px',
    minWidth: 190,
  };


  const getAttendedBodyCells = (row: IEnrollmentList) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "name")
        return {
          id: "name",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.name}</Typography>
            </TableCell>
          ),
        };



if (key === "statusString")
  return {
    id: "statusString",
    element: (
      <TableCell align="left" key={i}>
        <Select
          size="small"
          defaultValue={row.status || ""}
          onChange={(e) => handleStatusChange(row.enrollmentId, e.target.value)}
          sx={{ minWidth: 120 }}
        >
          {enrollmentStatus.map((status) => (
            <MenuItem key={status.id} value={status.id}>
              {status.english}
            </MenuItem>
          ))}
        </Select>
      </TableCell>
    ),
  };


      if (key === "department")
        return {
          id: "department",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.department}</Typography>
            </TableCell>
          ),
        };

      if (key === "email")
        return {
          id: "email",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.email}</Typography>
            </TableCell>
          ),
        };
      if (key === "phoneNumber")
        return {
          id: "phoneNumber",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.phoneNumber}</Typography>
            </TableCell>
          ),
        };
      if (key === "addition")
        return {
          id: "addition",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.addition}</Typography>
            </TableCell>
          ),
        };
      if (key === "involvement")
        return {
          id: "involvement",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.involvement}</Typography>
            </TableCell>
          ),
        };


      else return <></>;
    });

    return cells;
  };



  const getWaitingBodyCells = (row: IWaitingList) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "name")
        return {
          id: "name",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.name}</Typography>
            </TableCell>
          ),
        };

      if (key === "department")
        return {
          id: "department",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.department}</Typography>
            </TableCell>
          ),
        };

      if (key === "email")
        return {
          id: "email",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.email}</Typography>
            </TableCell>
          ),
        };
      if (key === "phoneNumber")
        return {
          id: "phoneNumber",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.phoneNumber}</Typography>
            </TableCell>
          ),
        };
      if (key === "addedDate")
        return {
          id: "addedDate",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {formatDateTime(row.addedDate)}
              </Typography>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const getInvitationsCells = (row: IWorkshopInvitations) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "employeeName")
        return {
          id: "employeeName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeName}</Typography>
            </TableCell>
          ),
        };

      if (key === "employeeId")
        return {
          id: "employeeId",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeId}</Typography>
            </TableCell>
          ),
        };

      if (key === "employeeEmail")
        return {
          id: "employeeEmail",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeEmail}</Typography>
            </TableCell>
          ),
        };
      if (key === "departmentName")
        return {
          id: "departmentName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.departmentName}</Typography>
            </TableCell>
          ),
        };
      if (key === "statusString")
        return {
          id: "statusString",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.statusString}</Typography>
            </TableCell>
          ),
        };
      if (key === "rejectionReason")
        return {
          id: "rejectionReason",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.rejectionReason}</Typography>
            </TableCell>
          ),
        };
      if (key === "createdOn")
        return {
          id: "createdOn",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {formatDateTime(row.createdOn)}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
                justifyContent={i18n.language === "en" ? "start" : "end"}
              >
                <Tooltip title={t("T_delete")}>
                  <IconButton
                    size={"small"}
                    color={"error"}
                    onClick={() => handleOpenDeleteInvitation(row)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Stack>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const getAssessmentsCells = (row: IWorkshopAssessments) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "assessmentDefinitionTitle") {
        // Get internalId from row, checking both camelCase and PascalCase
        const internalId = row.assessmentDefinitionInternalId || (row as any).AssessmentDefinitionInternalId;
        return {
          id: "assessmentDefinitionTitle",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.assessmentDefinitionTitle}
                {internalId && ` (${internalId})`}
              </Typography>
            </TableCell>
          ),
        };
      }

      if (key === "timeToComplete")
        return {
          id: "timeToComplete",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.timeToComplete}</Typography>
            </TableCell>
          ),
        };

      if (key === "typeName")
        return {
          id: "typeName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.typeName}</Typography>
            </TableCell>
          ),
        };
      if (key === "active")
        return {
          id: "active",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.active ? "Yes" : "No"}</Typography>
            </TableCell>
          ),
        };

      if (key === "numberOfEnrollments")
        return {
          id: "numberOfEnrollments",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.numberOfEnrollments}</Typography>
            </TableCell>
          ),
        };

        if (key === "numberOfEvaluations")
        return {
          id: "numberOfEvaluations",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.numberOfEvaluations}</Typography>
            </TableCell>
          ),
        };

        if (key === "pretestCount")
        return {
          id: "pretestCount",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.pretestCount}</Typography>
            </TableCell>
          ),
        };

        if (key === "posttestCount")
        return {
          id: "posttestCount",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.posttestCount}</Typography>
            </TableCell>
          ),
        };
      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
                justifyContent={i18n.language === "en" ? "start" : "end"}
              >
                {hasWorkshopDetailsAssessmentDelete && (
                  <Tooltip title={t("T_delete")}>
                    <IconButton
                      size={"small"}
                      color={"error"}
                      onClick={() => handleOpenDeleteAssessment(row)}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                )}
                {hasWorkshopDetailsAssessmentModify && (
                  <Tooltip title={t("T_edit")}>
                    <IconButton
                      size={"small"}
                      color={"default"}
                      onClick={() => handleOpenEditAssessment(row)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                )}
                {hasWorkshopDetailsAssessmentRead && (
                  <>
                    <Tooltip title={t("T_monitor")}>
                      <IconButton
                        size={"small"}
                        color={"default"}
                        onClick={() => handleOpenMonitorAssessment(row)}
                      >
                        <QueryStats />
                      </IconButton>
                    </Tooltip>
                    {(() => {
                      // Handle both camelCase and PascalCase property names
                      const isCertifiedtest = (row as any).isCertifiedtest ?? (row as any).IsCertifiedtest ?? false;
                      const shouldShowIcon = isCertifiedtest && hasWorkshopAssessmentVouchersRead;
                      
                      // if (isCertifiedtest !== undefined && isCertifiedtest) {
                      //   console.log('Voucher Icon Debug for row:', row.id, {
                      //     isCertifiedtest: isCertifiedtest,
                      //     hasRead: hasWorkshopAssessmentVouchersRead,
                      //     shouldShow: shouldShowIcon,
                      //     permissionState: {
                      //       hasWorkshopAssessmentVouchersRead,
                      //       hasWorkshopAssessmentVouchersModify,
                      //       hasWorkshopAssessmentVouchersPermission
                      //     }
                      //   });
                      // }
                      
                      return shouldShowIcon && (
                        <Tooltip title={t("T_vouchers") || "Vouchers"}>
                          <IconButton
                            size={"small"}
                            color={"primary"}
                            onClick={() => handleOpenVouchersModal(row)}
                          >
                            <CardGiftcard />
                          </IconButton>
                        </Tooltip>
                      );
                    })()}
                    <Tooltip title={t('T_questions_list') || 'Download Questions List'}>
                      <IconButton
                        size={"small"}
                        color={"success"}
                        onClick={(e) => openExportMenu(e, row)}
                        disabled={downloadingAssessmentId === row.id || downloadingExcelAssessmentId === row.id}
                      >
                        {(downloadingAssessmentId === row.id || downloadingExcelAssessmentId === row.id) ? (
                          <CircularProgress size={16} />
                        ) : (
                          <Download />
                        )}
                      </IconButton>
                    </Tooltip>
                    <Menu 
                      anchorEl={exportMenuAnchor?.element || null} 
                      open={exportMenuAnchor !== null && exportMenuAnchor.assessmentId === row.id}
                      onClose={closeExportMenu}
                    >
                      <MenuItem onClick={() => { closeExportMenu(); handleDownloadQuestionsListPdf(row); }}>
                        {t('T_download_template')?.replace('Template', 'PDF') || 'Download PDF'}
                      </MenuItem>
                      <MenuItem onClick={() => { closeExportMenu(); handleDownloadQuestionsListExcel(row); }}>
                        {t('T_export_excel') || 'Download Excel'}
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </Stack>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const getWorkshopAssessmentMonitorCells = (row: IWorkshopAssessmentMonitor) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "employeeName")
        return {
          id: "employeeName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeName}</Typography>
            </TableCell>
          ),
        };
      if (key === "startedOn")
        return {
          id: "startedOn",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.startedOn.toString()}</Typography>
            </TableCell>
          ),
        };

      if (key === "completed")
        return {
          id: "completed",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.completed == true ? "Yes" : "No"}</Typography>
            </TableCell>
          ),
        };

      if (key === "elapsedTime")
        return {
          id: "elapsedTime",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.elapsedTime}</Typography>
            </TableCell>
          ),
        };
      if (key === "questionsAnswered")
        return {
          id: "questionsAnswered",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.questionsAnswered}</Typography>
            </TableCell>
          ),
        };
      if (key === "employeeWorkshopAssessmentId")
        return {
          id: "employeeWorkshopAssessmentId",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
                justifyContent={i18n.language === "en" ? "start" : "end"}
              >
                {hasWorkshopDetailsAssessmentModify && (
                  <>
                    <Tooltip title={t("T_unfinish")}>
                      <IconButton
                        size={"small"}
                        color={"error"}
                        onClick={() => handleUnfinishAssessment(row)}
                      >
                        <Undo />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("T_reset")}>
                      <IconButton
                        size={"small"}
                        color={"default"}
                        onClick={() => handleResetAssessment(row)}
                      >
                        <RestartAlt />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </Stack>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const getWorkshopEvaluationListCells = (row: IWorkshopEvaluationListItem) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.title}</Typography>
            </TableCell>
          ),
        };
      if (key === "timeToComplete")
        return {
          id: "timeToComplete",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.timeToComplete > 0 ? Math.floor(row.timeToComplete / 60) : 0} {t("T_minutes")}</Typography>
            </TableCell>
          ),
        };
      if (key === "isActive")
        return {
          id: "isActive",
          element: (
            <TableCell align={"left"} key={i}>
              <Chip
                label={row.isActive ? t("T_active") : t("T_inactive")}
                color={row.isActive ? "success" : "default"}
                size="small"
              />
            </TableCell>
          ),
        };
      else return <></>;
    });

    // Always add actions column at the end
    cells.push({
      id: "actions",
      element: (
        <TableCell align={"left"} key="actions">
          <Stack
            direction={"row"}
            alignContent={"center"}
            spacing={1}
            justifyContent={i18n.language === "en" ? "start" : "end"}
          >
            {hasWorkshopDetailsEvaluationRead && (
              <Tooltip title={t("T_monitor")}>
                <IconButton
                  size={"small"}
                  color={"default"}
                  onClick={handleOpenMonitorEvaluation}
                >
                  <QueryStats />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </TableCell>
      ),
    });

    return cells;
  };

  const getWorkshopEvaluationMonitorCells = (row: IWorkshopEvaluationMonitor) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "employeeName")
        return {
          id: "employeeName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeName}</Typography>
            </TableCell>
          ),
        };
      if (key === "startedOn")
        return {
          id: "startedOn",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{formatDateTime(typeof row.startedOn === 'string' ? row.startedOn : row.startedOn.toISOString())}</Typography>
            </TableCell>
          ),
        };

      if (key === "completed")
        return {
          id: "completed",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.completed ? t("T_yes") : t("T_no")}</Typography>
            </TableCell>
          ),
        };

      if (key === "elapsedTime")
        return {
          id: "elapsedTime",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.elapsedTime} {t("T_minutes")}</Typography>
            </TableCell>
          ),
        };
      if (key === "questionsAnswered")
        return {
          id: "questionsAnswered",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.questionsAnswered}</Typography>
            </TableCell>
          ),
        };
      if (key === "employeeWorkshopEvaluationId")
        return {
          id: "employeeWorkshopEvaluationId",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
                justifyContent={i18n.language === "en" ? "start" : "end"}
              >
                {hasWorkshopDetailsEvaluationModify && (
                  <>
                    <Tooltip title={t("T_unfinish")}>
                      <IconButton
                        size={"small"}
                        color={"error"}
                        onClick={() => handleUnfinishEvaluation(row)}
                      >
                        <Undo />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("T_reset")}>
                      <IconButton
                        size={"small"}
                        color={"default"}
                        onClick={() => handleResetEvaluation(row)}
                      >
                        <RestartAlt />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </Stack>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const handleUnfinishEvaluation = async (row: IWorkshopEvaluationMonitor) => {
    if (!row)
      return setAlert({
        open: true,
        message: "No record selected",
        type: "error",
      });
    try {
      setLoadingEvaluationMonitor(true);
      await unfinishWorkshopEvaluation.mutateAsync(row.employeeWorkshopEvaluationId);
      setAlert({
        open: true,
        message: "Evaluation unfinished successfully",
        type: "success",
      });
      fetchEvaluationMonitor();
      setLoadingEvaluationMonitor(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoadingEvaluationMonitor(false);
    }
  };

  const handleResetEvaluation = async (row: IWorkshopEvaluationMonitor) => {
    if (!row)
      return setAlert({
        open: true,
        message: "No record selected",
        type: "error",
      });
    try {
      setLoadingEvaluationMonitor(true);
      await resetWorkshopEvaluation.mutateAsync(row.employeeWorkshopEvaluationId);
      setAlert({
        open: true,
        message: "Evaluation reset successfully",
        type: "success",
      });
      fetchEvaluationMonitor();
      setLoadingEvaluationMonitor(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoadingEvaluationMonitor(false);
    }
  };

  const handleUnfinishAssessment = async (row: IWorkshopAssessmentMonitor) => {
    if (!row)
      return setAlert({
        open: true,
        message: "No record selected",
        type: "error",
      });
    try {
      setLoading2(true);
      await unfinishWorkshopAssessment.mutateAsync(row.employeeWorkshopAssessmentId);
      setAlert({
        open: true,
        message: "Assessment unfinished successfully",
        type: "success",
      });
      fetchAssessmentMonitor();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleResetAssessment = async (row: IWorkshopAssessmentMonitor) => {
    if (!row)
      return setAlert({
        open: true,
        message: "No record selected",
        type: "error",
      });
    try {
      setLoading2(true);
      await resetWorkshopAssessment.mutateAsync(row.employeeWorkshopAssessmentId);
      setAlert({
        open: true,
        message: "Assessment reset successfully",
        type: "success",
      });
      fetchAssessmentMonitor();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDeleteInvitation = async () => {
    try {
      setLoading2(true);
      await deleteInvitationMutation.mutateAsync(selectedWorkshopInvitation.id);
      setAlert({
        open: true,
        message: "Workshop invitation deleted successfully",
        type: "success",
      });
      fetchData();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };



  return (
    <>
      <div>
        <BackButton path="/workshops" text={t("T_back_to_workshops")} />
      </div>
      <Stack spacing={2} p={2}>
        {/* Page Title */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          justifyContent={{ xs: "flex-start", md: "space-between" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          sx={{ mb: 4 }}
        >
          <Typography
            variant="h3"
            color={colors?.labelColor ? colors?.labelColor : "header.primary"}
            sx={{ mb: { xs: 1, md: 0 } }}
          >
            {t("T_workshop_details")}
          </Typography>

          <Stack
            direction="row"
            spacing={1.5}
            flexWrap="wrap"
            justifyContent={{ xs: "flex-start", md: "flex-end" }}
            sx={{ width: { xs: "100%", md: "auto" } }}
          >
            {hasReportsPermission && (
              <MuiButton
                variant="contained"
                size="medium"
                disabled={loadingCerts}
                onClick={handleDownloadAll}
                sx={{
                  ...dropdownButtonStyles,
                  bgcolor: 'success.main',
                  color: 'white',
                }}
              >
                {t('T_download_all_cetficates')}
                {loadingCerts && (
                  <CircularProgress
                    size={16}
                    sx={{ ml: 1, color: 'white' }}
                  />
                )}
              </MuiButton>
            )}

            {reportMenuItems.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                endIcon={<ExpandMore />}
                onClick={handleOpenReportsMenu}
                sx={dropdownButtonStyles}
              >
                {t('T_reports') || 'Reports'}
              </Button>
            )}

            {moreActionsMenuItems.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                endIcon={<ExpandMore />}
                onClick={handleOpenMoreActionsMenu}
                sx={dropdownButtonStyles}
              >
                {t('T_more_actions') || 'More Actions'}
              </Button>
            )}
          </Stack>
        </Stack>

        {reportMenuItems.length > 0 && (
          <Menu
            anchorEl={reportsMenuAnchor}
            open={reportsMenuOpen}
            onClose={handleCloseReportsMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { minWidth: 260 } }}
          >
            {reportMenuItems.map((item) => (
              item.to ? (
                <MenuItem
                  key={item.key}
                  component={Link}
                  to={item.to}
                  onClick={handleCloseReportsMenu}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {item.icon}
                    <span>{item.label}</span>
                    {item.showLoader && <CircularProgress size={14} />}
                  </Stack>
                </MenuItem>
              ) : (
                <MenuItem
                  key={item.key}
                  onClick={() => {
                    handleCloseReportsMenu();
                    item.action && item.action();
                  }}
                  disabled={item.disabled}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {item.icon}
                    <span>{item.label}</span>
                    {item.showLoader && <CircularProgress size={14} />}
                  </Stack>
                </MenuItem>
              )
            ))}
          </Menu>
        )}

        {moreActionsMenuItems.length > 0 && (
          <Menu
            anchorEl={moreActionsMenuAnchor}
            open={moreActionsMenuOpen}
            onClose={handleCloseMoreActionsMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { minWidth: 260 } }}
          >
            {moreActionsMenuItems.map((item) => (
              item.to ? (
                <MenuItem
                  key={item.key}
                  component={Link}
                  to={item.to}
                  onClick={handleCloseMoreActionsMenu}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {item.icon}
                    <span>{item.label}</span>
                  </Stack>
                </MenuItem>
              ) : (
                <MenuItem
                  key={item.key}
                  onClick={() => {
                    handleCloseMoreActionsMenu();
                    item.action && item.action();
                  }}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {item.icon}
                    <span>{item.label}</span>
                  </Stack>
                </MenuItem>
              )
            ))}
          </Menu>
        )}

        {/* Workshop Details Section */}
        {detailItems.length > 0 && (
          <Paper sx={{ p: 3 }}>
            <Typography
              variant="h4"
              color={"primary.main"}
              sx={{ mb: 2 }}
            >
              {t("T_details")}
            </Typography>
            <Grid container spacing={2}>
              {detailItems.map((item) => (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  <Typography variant="caption" color="text.secondary">
                    {item.label}
                  </Typography>
                  <Typography variant="subtitle1" color="text.primary">
                    {item.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Paper>
        )}

        <>
          <Stack direction="row" alignItems="center" spacing={2} style={{ paddingBlock: "30px" }}>
            <Typography
              variant="h3"
              color={"primary.main"}
            >
              {t("T_enrollment_list")}
            </Typography>
            {Workshop?.enrollmentList && Workshop.enrollmentList.length > 0 && (
              <Tooltip title={t('T_export_to_excel') || 'Export to Excel'}>
                <IconButton
                  onClick={handleExportEnrollmentList}
                  color="primary"
                  size="small"
                >
                  <FileDownload />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
          {Workshop!?.enrollmentList?.length > 0 && (
            <List
              headCells={AttendedListCells}
              data={Workshop!.enrollmentList}
              getBodyCells={getAttendedBodyCells}
              feature={feature}
              canEdit={false}
            />
          )}
          {(!Workshop?.enrollmentList ||
            Workshop?.enrollmentList?.length === 0) && (
              <EmptyContent
                icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                header={t("T_no_attended_list")}
                message={t("T_no_attended_list_message")}
              />
            )}
        </>

        {userType !== UserType.VENDOR_USER && (
          <div>
            <Typography
              variant="h3"
              color={"primary.main"}
              style={{ paddingBlock: "30px" }}
            >
              {t("T_waiting_list")}
            </Typography>
            {Workshop!?.waitingList?.length > 0 && (
              <List
                headCells={WaitingListCells}
                data={Workshop!.waitingList}
                getBodyCells={getWaitingBodyCells}
                feature={feature}
                canEdit={false}
              />
            )}
            {(!Workshop?.waitingList ||
              Workshop?.waitingList?.length === 0) && (
                <EmptyContent
                  icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                  header={t("T_no_waiting_list")}
                  message={t("T_waiting_list_message")}
                />
              )}
          </div>
        )}

        {userType !== UserType.VENDOR_USER && (
          <div>
            <div style={{ paddingBlock: '30px' }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>

                <Typography
                  variant="h3"
                  color={"primary.main"}
                >
                  {t("T_workshop_invitations_list")}
                </Typography>
                {Workshop?.workshopDetails[0].canInvite && <Tooltip title={t('T_add')}>
                  <IconButton
                    sx={{
                      // bgcolor: 'primary.main',
                      color: "primary.main",
                      "&:hover": {
                        bgcolor: "primary.light",
                        color: "white",
                      },
                      height: 40,
                      width: 40,
                      transition: "0.5s",
                    }}
                    onClick={handleOpenAddInvitation}
                  >
                    <Add />
                  </IconButton>
                </Tooltip>}

              </div>
              {!Workshop?.workshopDetails[0].canInvite && <Typography variant="caption">Invitations cannot be sent. Please assign a venue, set a capacity, and add a trainer</Typography>
              }
            </div>
            {Invitations?.length > 0 && (
              <List
                headCells={InvitationCells}
                data={Invitations}
                getBodyCells={getInvitationsCells}
                feature={feature}
                canEdit={false}
              />
            )}

            {(!Invitations ||
              Invitations?.length === 0) && (
                <EmptyContent
                  icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                  header={t("T_no_invitation_list")}
                  message={t("T_no_invitation_list_message")}
                />
              )}
          </div>
        )}

        {/* Workshop Evaluation Section */}
        {hasWorkshopDetailsEvaluationPermission && (
          <div>
            <Typography
              variant="h3"
              color={"primary.main"}
              style={{ paddingBlock: "30px" }}
            >
              {t("T_workshop_evaluation")}
            </Typography>
            {workshopEvaluationList?.length > 0 && (
              <List
                headCells={WorkshopEvaluationListCells}
                data={workshopEvaluationList}
                getBodyCells={getWorkshopEvaluationListCells}
                feature={feature}
                canEdit={false}
              />
            )}
            {workshopEvaluationList?.length === 0 && (
              <EmptyContent
                icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                header={t("T_no_evaluation")}
                message={t("T_no_evaluation_message")}
              />
            )}
          </div>
        )}

        {hasWorkshopDetailsAssessmentPermission && (
          <div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>

              <Typography
                variant="h3"
                color={"primary.main"}
                style={{ paddingBlock: "30px" }}
              >
                {t("T_workshop_assessments")}
              </Typography>
              {(userType === UserType.VENDOR_ADMIN || userType == UserType.VENDOR_USER) && (
                <Tooltip title={t('T_add')}>
                  <IconButton
                    sx={{
                      // bgcolor: 'primary.main',
                      color: "primary.main",
                      "&:hover": {
                        bgcolor: "primary.light",
                        color: "white",
                      },
                      height: 40,
                      width: 40,
                      transition: "0.5s",
                    }}
                    onClick={handleOpenAddAssessment}
                  >
                    <Add />
                  </IconButton>
                </Tooltip>
              )}
            </div>

            {workshopAssessments?.length > 0 && (
              <List
                headCells={WorkshopAssessmentsCells}
                data={workshopAssessments}
                getBodyCells={getAssessmentsCells}
                feature={feature}
                canEdit={false}
              />
            )}
            {(
              workshopAssessments?.length === 0) && (
                <EmptyContent
                  icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                  header={t("T_no_assessments")}
                  message={t("T_no_assessments")}
                />
              )}
          </div>
        )}



      </Stack>

      {openAddInvitation && (
        <AddWorkshopInvitations2
          open={openAddInvitation}
          loading={loading2}
          uninvitedEmployeesList={filteredUninvitedEmployeesList}
          onClose={handleClose}
          onSubmit={handleSendInvitations}
        />
      )}
      {openDeleteInvitation && (
        <DeleteWorkshopInvitation
          open={openDeleteInvitation}
          loading={loading2}
          onClose={handleClose}
          onSubmit={handleDeleteInvitation}
        />
      )}


      {openAddAssessment && (
        <AddWorkshopAssessment
          open={openAddAssessment}
          loading={loading2}
          vendorAssessmentTypes={vendorAssessmentTypes}
          vendorAssessmentDefinitions={vendorAssessmentDefinitions}
          onClose={handleClose}
          onSubmit={handleAddAssessment}
          onChanges={handleWorkshopAssessmentChange} />
      )}
      {openDeleteAssessment && (
        <DeleteWorkshopAssessment
          open={openDeleteAssessment}
          loading={loading2}
          onClose={handleClose}
          onSubmit={handleDeleteAssessment}
        />
      )}

      {openEditAssessment && (
        <EditWorkshopAssessment
          open={openEditAssessment}
          loading={loading2}
          workshopAssessment={selectedWorkshopAssessment}
          onClose={handleClose}
          onSubmit={handleEditAssessment}
          onChanges={handleWorkshopAssessmentChange}
        />
      )}


      {openMonitorAssessment && (
        <Modal
          onClose={handleClose}
          title={t('T_monitor') + ' ' + selectedWorkshopAssessment.typeName + ' ' + t('T_assessment')}
          maxWidth="lg"
          children={<div style={{ position: 'relative', padding: 10, marginBlock: 20, minHeight: 120 }}>
            {loadingMonitor && (
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
                <CircularProgress />
              </div>
            )}
            <List
              headCells={WorkshopAssessmentMonitorCells}
              data={workshopAssessmentMonitorList}
              getBodyCells={getWorkshopAssessmentMonitorCells}
              feature={feature}
              canEdit={false} />
          </div>}
          actions={null} open={openMonitorAssessment} />
      )}

      {openVouchersModal && (
        <VoucherEmployeesModal
          open={openVouchersModal}
          loading={loadingVouchers}
          employees={employeesWithVouchers}
          hasModifyPermission={hasWorkshopAssessmentVouchersModify}
          onClose={handleCloseVouchersModal}
          onSendVouchers={handleSendVouchers}
        />
      )}

      {openPhotosModal && (
        <WorkshopPhotosModal
          open={openPhotosModal}
          onClose={() => setOpenPhotosModal(false)}
          workshopId={id}
        />
      )}

      {openMonitorEvaluation && (
        <Modal
          onClose={handleClose}
          title={t('T_monitor') + ' ' + t('T_workshop_evaluation')}
          maxWidth="lg"
          children={<div style={{ position: 'relative', padding: 10, marginBlock: 20, minHeight: 120 }}>
            {loadingEvaluationMonitor && (
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
                <CircularProgress />
              </div>
            )}
            <List
              headCells={WorkshopEvaluationMonitorCells}
              data={workshopEvaluationMonitorList}
              getBodyCells={getWorkshopEvaluationMonitorCells}
              feature={feature}
              canEdit={false} />
          </div>}
          actions={null} open={openMonitorEvaluation} />
      )}

    </>
  );
};

export default WorkshopDetails;
